module.exports = {"root":[{"value":"None","label":"无"},{"value":"Point","label":"点"},{"value":"LineString","label":"线"},{"value":"Polygon","label":"多边形"},{"value":"Circle","label":"圆"},{"value":"Square","label":"正方形"},{"value":"Rectangle","label":"长方形"}]}


//////////////////
// WEBPACK FOOTER
// ./static/json/drawType.json
// module id = O9Zf
// module chunks = 3